import type { ConversationNodeChatbot } from 'lib-shared-types-api';

type Props = {
  node: ConversationNodeChatbot;
};

const exitReasonLabel: Record<string, string> = {
  HANDOFF_VIA_QUEUE: 'Handoff via queue',
  HANDOFF_VIA_BREAKING_CONTAINMENT: 'Handoff via continue with flow',
  HANDOFF_FAILED: 'Handoff',
  PROMPT_INJECTION: 'Prompt injection',
  BLOCKED_BY_CONTENT_POLICY: 'Blocked by content policy',
  UNABLE_TO_HANDLE: 'Unable to handle',
  UNSUPPORTED_MESSAGE: 'Unsupported message',
  UNKNOWN: 'Unknown',
};
export function RoutedThroughChatbot({ node }: Props): JSX.Element {
  return (
    <>
      AI agent
      {node.chatbot_name && (
        <>
          : <strong>{node.chatbot_name}</strong>
        </>
      )}{' '}
      {node.exit_reason && exitReasonLabel[node.exit_reason] && (
        <>
          · <strong>{exitReasonLabel[node.exit_reason]}</strong>
        </>
      )}
    </>
  );
}
